<template>
    <div class="trading-desk-container soldwines-mobile-wrapper">
        <v-layout column wrap fill-height>
            <div class="trading-desk-container1" v-if="!isLogged">
                <div class="wine-market-wrapper">
                    <h3>My portfolio</h3>
                    <div class="no-fav">
                        <div>Join Vindome to start building your collection of favourite wines</div>
                        <button class="btn-primary goto-market-btn" v-on:click="() => goToLogin()">Join Vindome</button>
                    </div>
                </div>
            </div>

            <div class="my-investments">
                <div class="investments-item">
                    <div class="investments-label">{{ $t('gross-profit') }}</div>
                    <div class="bold">{{ soldWinesSummary.grossProfit ? formatPrice(soldWinesSummary.grossProfit.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) : 0 }}</div>
                </div>
                <div class="investments-item">
                    <div class="investments-label">{{ $t('net-profit') }}</div>
                    <div class="bold">{{ soldWinesSummary.netProfit ? formatPrice(soldWinesSummary.netProfit.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) : 0 }}</div>
                </div>
                <div class="investments-item total-gain">
                    <div class="investments-label">{{ $t('roi') }}</div>
                    <div class="rate-wrapper">
                        <!--                                                    <div class="bold">{{soldWinesSummary.roiPercentageGross}}%</div>-->
                        <div class="bold">{{ soldWinesSummary.roiPercentageGross ? soldWinesSummary.roiPercentageGross.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.') : 0 }}%</div>
                        <div class="performance down" v-if="soldWinesSummary.roiPercentageGross < 0"></div>
                        <div class="performance up"></div>
                    </div>
                </div>
                <div class="investments-item">
                    <div class="investments-label">{{ $t('bottles-sold') }}</div>
                    <div class="bold">{{soldWinesSummary.bottleSold}}</div>
                </div>
            </div>

            <div v-if="soldWinesList.length > 0">
                <v-row v-for="soldWineItem in soldWinesList" :key="soldWineItem.wineVintageId" no-gutters class="portfolio-row">
                    <div class="wine-details-head">
                        <div v-if="soldWineItem.wineDisplayName">
                            <h2 v-on:click="() => goToWineDetails('sold-wines', soldWineItem)">{{soldWineItem.wineDisplayName}}</h2>
                            <h3 v-if="soldWineItem.isSecondLabel" class="addition-description">2-nd label of {{soldWineItem.producerType}} {{soldWineItem.producer}}</h3>
                            <h3 v-else class="addition-description">{{soldWineItem.producerType}} {{soldWineItem.producer}}</h3>
                        </div>
                        <div v-else>
                            <h2 v-on:click="() => goToWineDetails('sold-wines', soldWineItem)">{{soldWineItem.vintage}} {{soldWineItem.producerType}} {{soldWineItem.producer}}</h2>
                        </div>
<!--                        <div v-if="portfolioItem.isEnPrimeur" class="wine-enprimeur">En Primeur</div>-->
                        <div class="wine-summary-wrapper" v-if="soldWineItem.summaryWines">
                            <div class="wine-summary-row">
                                <div class="wine-summary-row-title">{{ $t('gross-profit') }}</div>
                                <div class="wine-summary-row-value">{{ formatPrice(soldWineItem.summaryWines.grossProfit.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                            </div>
                            <div class="wine-summary-row">
                                <div class="wine-summary-row-title">{{ $t('net-profit') }}</div>
                                <div class="wine-summary-row-value">{{ formatPrice(soldWineItem.summaryWines.netProfit.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                            </div>
                            <div class="wine-summary-row">
                                <div class="wine-summary-row-title">{{ $t('roi') }}</div>
                                <div class="wine-summary-row-value">
                                    <div class="wine-summary-row-value1">{{soldWineItem.summaryWines.roiPercentageGross.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')}}%</div>
                                    <div class="wine-summary-row-value3 down" v-if="soldWineItem.summaryWines.roiPercentageGross < 0"></div>
                                    <div class="wine-summary-row-value3 up" v-else></div>
                                </div>
                            </div>
                            <div class="wine-summary-row">
                                <div class="wine-summary-row-title">{{ $t('bottles-sold') }}</div>
                                <div class="wine-summary-row-value">{{soldWineItem.summaryWines.bottleSold}}</div>
                            </div>
                            <div class="wine-summary-row last-child">
                                <div class="perform-btn" v-on:click="() => openWinePerformance('sold-wines', soldWineItem)">{{ $t('wine-performance') }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="mobile-wines-header" :class="{de: $i18n.locale === 'de', it: $i18n.locale === 'it'}">
                        <div>{{ $t('case-size') }}</div>
                        <div>{{ $t('sell-date') }}</div>
                        <div>{{ $t('cases-sold') }}</div>
                        <div>{{ $t('sell-price') }}</div>
                        <div>{{ $t('total-sell-amount') }}</div>
                        <div>{{ $t('revenue') }}</div>
                        <div>{{ $t('gross-profit') }}</div>
                        <div>{{ $t('sell-order-no') }}</div>
                    </div>
                    <div class="mobile-wines-body">
                        <div v-for="(sellTransaction, index) in soldWineItem.sellTransactions" :key="index">
                            <div class="mobile-wines-row">
                                <div class="mobile-wines-div">
                                    {{sellTransaction.caseSize}}
                                </div>
                                <div class="mobile-wines-div">
                                    {{formatDate(sellTransaction.sellDate)}}
                                </div>
                                <div class="mobile-wines-div">
                                    {{sellTransaction.casesSold}}
                                </div>
                                <div class="mobile-wines-div">
                                    {{formatPrice(sellTransaction.sellPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}
                                </div>
                                <div class="mobile-wines-div">
                                    {{formatPrice(sellTransaction.totalSellAmount.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}
                                </div>
                                <div class="mobile-wines-div">
                                    {{formatPrice(sellTransaction.revenue.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}
                                </div>
                                <div class="mobile-wines-div">
                                    {{formatPrice(sellTransaction.grossProfit.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.'))}}
                                </div>
                                <div class="mobile-wines-div">
                                    <div class="wine-portfolio-trades-box-value link" v-on:click="() => $emit('triggerSalesInvoiceDetailsPage', sellTransaction.saleOrderId)">no. {{sellTransaction.saleOrderId}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-row>
            </div>
            <div class="no-orders-info" v-if="soldWinesList.length == 0">{{ $t('no-sold-wines') }}</div>

        </v-layout>
    </div>
</template>

<script>
import {APortfolio, AWines} from "@/store/actions";
import {mapActions, mapGetters} from "vuex";
import {GPortfolio, GUser} from "@/store/getters";
import moment from "moment";

export default {
    name: "SoldWinesScreenMobile",
    computed: {
        ...mapGetters({
            soldWinesList: GPortfolio.GET_SOLD_WINES_LIST,
            soldWinesSummary: GPortfolio.GET_SOLD_WINES_SUMMARY,
            isLogged: GUser.GET_USER_LOGGED
        })
    },
    methods: {
        ...mapActions({
            loadSoldWinesSummary: APortfolio.GET_SOLD_WINES_SUMMARY,
            loadSoldWinesList: APortfolio.GET_SOLD_WINES_LIST
        }),
        formatPrice(price) {
            return `€ ${price}`
        },
        formatDate(date) {
            return moment(date).locale(this.$i18n.locale).format('DD MMM YYYY')
        },
        goToLogin() {
            this.$router.push(this.localePath({ path: '/login' }));
        },
        goToWineDetails(location = '', item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, { wineId: item.wineId, caseSize: (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId), languageId: this.$i18n.locale });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({ path: '/wine-details/' + item.wineId + '/' + (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId) + '/' + (typeof item.appellation !== 'undefined' && item.appellation ? item.appellation.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.classification !== 'undefined' && item.classification) ? item.classification.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.color !== 'undefined' && item.color) ? item.color.toLowerCase() : "") + '-' + ((typeof item.producerName !== 'undefined' && item.producerName) ? item.producerName.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.producerTypeName !== 'undefined' && item.producerTypeName) ? item.producerTypeName.toLowerCase().split(' ').join('-') : "") }));
            })
        },
        openWinePerformance(location = "", item) {
            this.$store.dispatch(AWines.SELECT_WINE_ID, { wineId: (item.wineVintageId ? item.wineVintageId : item.wineId), caseSize: (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId), languageId: this.$i18n.locale });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({ path: '/wine-performance/' + (item.wineVintageId ? item.wineVintageId : item.wineId) + '/' + (location === 'sold-wines' ? item.sellTransactions[0].caseSizeId : item.casesSizes[0].caseSizeId) + '/' + (typeof item.appellation !== 'undefined' && item.appellation ? item.appellation.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.classification !== 'undefined' && item.classification) ? item.classification.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.color !== 'undefined' && item.color) ? item.color.toLowerCase() : "") + '-' + ((typeof item.producerName !== 'undefined' && item.producerName) ? item.producerName.toLowerCase().split(' ').join('-') : "") + '-' + ((typeof item.producerTypeName !== 'undefined' && item.producerTypeName) ? item.producerTypeName.toLowerCase().split(' ').join('-') : "") }));
            })
        },
    },
    mounted() {
        if (this.isLogged) {
            this.loadSoldWinesSummary();
            this.loadSoldWinesList();
        }
    }
}
</script>

<style>
.soldwines-mobile-wrapper .my-investments {
    width: 100%;
    border-radius: 8px;
    background-color: #E1C376;
    padding: 20px 13px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
}
.soldwines-mobile-wrapper .my-investments .investments-item {
    text-align: right;
    border-right: 1px solid #FADF95;
    display: inline-block;
    width: 50%;
    padding-right: 15px;
}
.soldwines-mobile-wrapper .my-investments .investments-item:nth-child(2) {
    border: 0;
    padding: 0;
}
.soldwines-mobile-wrapper .my-investments .investments-item:nth-child(3) {
    padding-top: 15px;
}
.soldwines-mobile-wrapper .my-investments .investments-item:last-child {
    padding-top: 15px;
    padding-right: 0;
    border: 0;
}
.soldwines-mobile-wrapper .my-investments .investments-label {
    color: #FBEAC0;
    line-height: 15px;
    margin-bottom: 2px;
}
.soldwines-mobile-wrapper .my-investments .bold {
    color: #fff;
    font-weight: 500;
    font-size: 15px;
}
.soldwines-mobile-wrapper .portfolio-row {
    margin-top: 30px;
    background-color: #FFF;
    border-radius: 8px;
    padding: 8px;
}
.soldwines-mobile-wrapper .wine-details-head .addition-description {
    font-family: Roboto,sans-serif;
    font-weight: normal;
    font-size: 15px;
    margin-bottom: 0;
    color: #000;
}
.soldwines-mobile-wrapper .wine-details-head h2 {
    font-size: 20px;
    line-height: 22px;
    color: var(--black);
    padding: 10px 5px 5px;
}
.soldwines-mobile-wrapper .wine-summary-wrapper {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 8px;
    margin-top: 13px;
    margin-bottom: 13px;
    display: flex;
    flex-wrap: wrap;
}
.soldwines-mobile-wrapper .wine-summary-row {
    width: 50%;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding-left: 0;
    border: 0;
}

.soldwines-mobile-wrapper .wine-summary-row:nth-child(1),
.soldwines-mobile-wrapper .wine-summary-row:nth-child(2) {
    margin-bottom: 10px;
}

.soldwines-mobile-wrapper .wine-summary-row.last-child {
    max-width: 100%;
    width: 100%;
    margin-top: 10px;
}

.soldwines-mobile-wrapper .wine-summary-row-title {
    color: rgba(0, 0, 0, 0.64);
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 4px;
}

.soldwines-mobile-wrapper .wine-summary-row-value {
    font-size: 18px;
    line-height: 29px;
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
}

.soldwines-mobile-wrapper .wine-summary-row-value1, .soldwines-mobile-wrapper .wine-summary-row-value2, .soldwines-mobile-wrapper .wine-summary-row-value3 {
    display: inline-block;
}

.soldwines-mobile-wrapper .wine-summary-row-value1 {
    margin-right: 5px;
}

.soldwines-mobile-wrapper .wine-summary-row-value3.up {
    width: 16px;
    height: 17px;
    background: url('../assets/price-up.png') no-repeat center;
}
.soldwines-mobile-wrapper .wine-summary-row-value3.down {
    width: 16px;
    height: 17px;
    background: url('../assets/price-down.png') no-repeat center;
}
.soldwines-mobile-wrapper .perform-btn {
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    border: 1px solid var(--light-gray);
    border-radius: 4px;
    text-align: center;
    padding: 10px;
    margin-top: 4px;
}

.soldwines-mobile-wrapper .perform-btn:hover {
    cursor: pointer;
}

.soldwines-mobile-wrapper .mobile-wines-header {
    width: 100%;
    padding: 0 0 10px;
    display: flex;
    flex-wrap: wrap;
}

.soldwines-mobile-wrapper .mobile-wines-header div {
    color: rgba(0, 0, 0, 0.64);
    font-size: var(--fs-small);
    font-weight: 300;
    box-shadow: none !important;
    height: 20px;
    white-space: nowrap;
    display: inline-block;
    width: 33.33%;
}

.soldwines-mobile-wrapper .mobile-wines-header.de div,
.soldwines-mobile-wrapper .mobile-wines-header.it div {
    margin: 7px 0;
    color: rgba(0, 0, 0, 0.64);
    font-size: var(--fs-small);
    font-weight: 300;
    box-shadow: none !important;
    height: 20px;
    display: inline-block;
    width: 33.33%;
    line-height: 15px;
    white-space: break-spaces;
}

.soldwines-mobile-wrapper .mobile-wines-body {
    width: 100%;
}

.soldwines-mobile-wrapper .mobile-wines-row {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 0;
    border-top: 1px solid #b2b2b2;
}

.soldwines-mobile-wrapper .mobile-wines-div {
    display: inline-block;
    width: 33.33%;
    vertical-align: top;
    padding: 5px 0;
    font-weight: 600;
    color: var(--black)
}

.soldwines-mobile-wrapper .wine-portfolio-trades-box-value.link {
    font-weight: 600;
    color: #004F7F;
    cursor: pointer;
}
</style>
